module.exports = __webpack_public_path__ + "img/1507555838.2f7ff02c.jpg";